import { render, staticRenderFns } from "./DataExchangeTable.vue?vue&type=template&id=58aea828&scoped=true"
import script from "./DataExchangeTable.vue?vue&type=script&lang=ts"
export * from "./DataExchangeTable.vue?vue&type=script&lang=ts"
import style0 from "./DataExchangeTable.vue?vue&type=style&index=0&id=58aea828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58aea828",
  null
  
)

export default component.exports